import React from 'react';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp, { FlexRowContainer } from 'components/StyledComp';

const propTypes = {
};

@autobind
class Footer extends BaseComponent {
  constructor(props) {
    super(props);
  }

  renderContent() {
    const { ...layoutProps } = this.props;

    return (
      <FlexRowContainer
        {...layoutProps}
        width="match_parent" // Needed because layoutProps maybe empty when switching route.
        height="wrap_content" // Needed because layoutProps maybe empty when switching route.
        alignItems="center"
      >
        <styledComp.Span
          width="wrap_content"
          height="wrap_content"
          color="textSecondaryLight"
          fontSize="14px"
        >
          {/* eslint-disable-next-line */}
          Copyright © {new Date().getFullYear()} HHAPlus.com. All rights reserved.
        </styledComp.Span>
      </FlexRowContainer>
    );
  }
}

Footer.propTypes = propTypes;

export default Footer;
